import router from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/token";
import useAccountStore from "@/store/modules/account";
import { isNull } from "./utils/fangerUtils";

// 切换路由进度条
NProgress.configure({ showSpinner: false });

// 白名单 不做拦截的请求
const whiteList = ["/login"];


/**
 *  路由前置守卫 路由鉴权 全局路由守卫
 *  @param {*} to 要跳转到哪里去
 *  @param {*} from 你从哪里来
 *  @param {*} next 是否要去？
 */

router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();
  // 有token 状态
  if (getToken()) {
    // 不允许进入登录页
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      // 判断是否有用户信息，没有先获取用户信息
      if (isNull(useAccountStore().userInfo)) {
        useAccountStore().getUserInfo().then(res => {
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
        })
      } else {
        next();
      }
    }
  } else {
    // 没有 to'ken白名单直接进入，不在白名单，进入登录页
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
